import { Universe } from '../types/content';

export const universes: Universe[] = [
  {
    id: 'spectacle',
    index: '01',
    title: 'Spectacle vivant & décors de tournée',
    short: 'Spectacle & tournée',
    description:
      'Décors démontables, allégés et classés M1, pensés pour un montage express et un calage camion millimétré.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/4cdd3135-04ce-4446-8e55-acabc85bda6b.jpg',
    tags: ['Démontable', 'Classé M1', 'Calage camion'],
  },
  {
    id: 'sculpture',
    index: '02',
    title: 'Sculptures & volumes monumentaux 3D',
    short: 'Sculpture monumentale',
    description: 'Du fichier 3D à la pièce de 14 m : usinage robot, puis peau en résine projetée Polyspray.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/c70fd65f-3941-439c-a574-58a63a2e824d.jpg',
    tags: ['Polyspray', 'Robot 5 axes'],
  },
  {
    id: 'lumiere',
    index: '03',
    title: 'Parcours lumineux & scénographie nocturne',
    short: 'Parcours lumineux',
    description: 'Structures acier et volumes translucides qui intègrent la lumière et tiennent les saisons.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/2c7cbc40-c91c-404f-91df-3de34cb2e50a.jpg',
    tags: ['Acier', 'Extérieur'],
  },
  {
    id: 'evenementiel',
    index: '04',
    title: 'Événementiel, PLV grand format & prototypage',
    short: 'Événementiel & PLV',
    description: 'Objets de marque surdimensionnés, prototypes et PLV XXL livrés dans des délais serrés.',
    image: 'https://cdn.magicpatterns.com/patterns/generated-images/362f5dfa-d059-42c6-ba6f-b9704426f74b.jpg',
    tags: ['PLV XXL', 'Prototype', 'Délais courts'],
  },
];
